/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LaptopIcon = /*#__PURE__*/ createSvgIcon(
  'LaptopIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M.75 17a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 01.75 15.5H2v-11c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06v11h1.25c.212 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H.75zm7.751-2h3.007c.134 0 .249-.05.346-.15a.487.487 0 00-.004-.7.48.48 0 00-.351-.15H8.492a.467.467 0 00-.346.15.486.486 0 00.004.7c.1.1.217.15.351.15zM3.5 13h13V4.5h-13V13z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default LaptopIcon;
